import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import ContextOfChildComponent from "../../components/applicationComponents/contextOfChild/ContextOfChildComponent";

export default function ContextOfChildPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Context of the child Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ContextOfChildComponent disabled={false} />
    </>
  );
}
